import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./featured/Featured";

import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const PythonReport = () => {
  const [reportData, setReportData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const response = await axios.get('http://127.0.0.1:5000/api/python-report');
        console.log('Réponse:', response.data);
  
        if (response.data.products && Array.isArray(response.data.products)) {
          setReportData(response.data.products);
        } else {
          throw new Error('Les données ne sont pas sous forme de tableau');
        }
      } catch (err) {
        console.error('Erreur:', err);
        setError('Erreur lors de la récupération du rapport Python.');
      } finally {
        setLoading(false);
      }
    };
  
    fetchReportData();
  }, []);
  

  if (loading) {
    return <div>Chargement du rapport...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (reportData.length === 0) {
    return <div>Aucune donnée disponible pour le rapport.</div>;
  }

  // Calcul des nombres de produits par catégorie
  const categories = ['Electronique', 'Cuisine', 'Soins et Beauté', 'Vêtements', 'Téléphones et Tablette', 'Maison et Bureau'];
  const categoryCounts = categories.reduce((acc, category) => {
    acc[category] = reportData.filter(item => item.category === category).length;
    return acc;
  }, {});

  const chartDataDoughnut = {
    labels: ['Electronique', 'Cuisine', 'Soins et Beauté', 'Vêtements', 'Téléphones et Tablette','Maison et Bureau'],
    datasets: [
      {
        label: 'Nombre de Produits',
        data: [
          categoryCounts['Electronique'],
          categoryCounts['Cuisine'],
          categoryCounts['Soins et Beauté'],
          categoryCounts['Vêtements'],
          categoryCounts['Téléphones et Tablette'],
          categoryCounts['Maison et Bureau'],
        ],
        backgroundColor: ['#9caf7d', '#D8DBBD', '#B59F78', '#2A3663', '#FAF6E3','#FF9F40'],
        hoverOffset: 5,
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        position: 'right',  // Positionner la légende à droite du graphique
      },
    },
  };

  return (
    <div className="featured">
      <div className="mt-4">
        {reportData.length > 0 ? (
          <>
            <p style={{color: 'rgb(160, 160, 160)'}}>Nombre de Produits par Catégorie</p>
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <div style={{ width: '41%',marginLeft:'130px' }}>
                <Doughnut data={chartDataDoughnut} options={chartOptions} />
              </div>
            </div>
          </>
        ) : (
          <p>Aucune donnée disponible pour le rapport.</p>
        )}
      </div>
    </div>
  );
};

export default PythonReport;
